import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ed5c340"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "index" }
const _hoisted_2 = { class: "media" }
const _hoisted_3 = ["onClick", "onContextmenu"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mediaList, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "media-item",
          key: item.mangaId,
          onClick: ($event: any) => ($setup.go_manga_list(item)),
          onContextmenu: _withModifiers($setup.context_menu, ["prevent"])
        }, _toDisplayString($setup.get_last_str(item.parentPath)), 41 /* TEXT, PROPS, HYDRATE_EVENTS */, _hoisted_3))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}